import Backbone from 'backbone'
import _ from 'lodash'
import template from 'scoreboard/charts/edit/serie/serie-periods-form.hbs'
import FormView from 'scoreboard/components/form-view'
import SeriePeriodForm from 'scoreboard/charts/edit/serie/serie-period-form'

const SeriePeriodsForm = Backbone.View.extend({
	tagName: 'form',

	initialize: function (options = {}) {
		this.options = options
		this.chart = options.chart

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true
		})
	},

	render: function() {
		this.$el.empty().append(template())

		this.seriePeriodForms = this.collection.models.map(period => {
			const periodEditor = new SeriePeriodForm({
				model: period,
				calendarId: this.chart.periodGroupCalendarId(period)
			})
			this.$('.dialog-body-content').append(periodEditor.el)
			periodEditor.render()

			return periodEditor
		})

		this.formView.start()

		return this
	},

	submit: function() {
		_.range(this.seriePeriodForms.length).forEach(index => {
			const periodEditor = this.seriePeriodForms[index]
			this.collection.add(periodEditor.getPeriod(), { merge: true })
		})
		this.trigger('done')
	},
	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, ...this.seriePeriodForms], 'remove')
	}
})

export default SeriePeriodsForm
SeriePeriodsForm.__filename__ = 'charts/edit/serie/serie-periods-form.js'
